import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import deviceType from '@/types/DeviceType';
import {
  visibleDeviceTypes,
  DEVICE_TYPE,
  TELTONIKA_DEVICE_TYPE,
  TELTONIKA_MAKER_ID,
} from '@/services/consts';
import { computed, onMounted } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SingleDeviceTypeAutoComplete',
  props: {
    modelValue: {},
    initialItemId: {},
    makerId: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

onMounted(() => {
  if (props.initialItemId) {
    setModelValue();
  }
});

const localModelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const selectableDeviceTypes = computed(() => {
  if (props.makerId) {
    return props.makerId === TELTONIKA_MAKER_ID ? TELTONIKA_DEVICE_TYPE : DEVICE_TYPE;
  }

  return visibleDeviceTypes;
})

function setModelValue() {
  if (props.initialItemId) {
    localModelValue.value = visibleDeviceTypes.filter((item) => {
      return item.id === props.initialItemId
    })[0];
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: localModelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModelValue).value = $event)),
    label: _unref(i18n).global.t('pages.common.autocomplete.deviceType'),
    itemName: "type",
    items: selectableDeviceTypes.value,
    "initial-item-id": props.initialItemId,
    "error-messages": __props.errorMessages
  }, null, 8, ["modelValue", "label", "items", "initial-item-id", "error-messages"]))
}
}

})